module.exports = require('./componentPropType')
